import TasksViewShell from '../TasksViewShell';
import Kanban from './Kanban';

const Board = () => (
    <TasksViewShell contentClassName="task-board-page__kanban">
        <Kanban />
    </TasksViewShell>
);

export default Board;
